import { all, takeLeading, takeEvery, put, select } from 'redux-saga/effects';
import { api, apiCall } from 'redux/helpers/api';
import { authSelectors } from 'redux/auth';
import { snackbarActions } from 'redux/snackbar';
import types from './types';
import actions from './actions';

function* onGetAll() {
  const workspaceId = yield select(authSelectors.getWorkspaceId);
  const { ok, response, error } = yield apiCall(api.integrations.getAll, { workspaceId });
  if (ok) {
    yield put(actions.getAllSuccess(response));
  } else {
    yield put(actions.getAllFailure(error));
    yield put(snackbarActions.createFailure(error.message));
  }
}

function* onUpdate({ payload }) {
  const workspaceId = yield select(authSelectors.getWorkspaceId);
  const { ok, response, error } = yield apiCall(api.integrations.update, { workspaceId, ...payload });
  if (ok) {
    yield put(actions.updateSuccess(response));
    yield put(snackbarActions.createSuccess('integrations:settingsForm.settingsSaved', { translate: true }));
  } else {
    yield put(actions.updateFailure(error));
    yield put(snackbarActions.createFailure(error.message));
  }
}

function* onSync({ payload }) {
  const workspaceId = yield select(authSelectors.getWorkspaceId);
  const { ok, response, error } = yield apiCall(api.integrations.sync, { workspaceId, ...payload });
  if (ok) {
    yield put(actions.syncSuccess(response));
  } else {
    yield put(actions.syncFailure(error));
    yield put(snackbarActions.createFailure(error.message));
  }
}

export default function* integrationsSagas() {
  yield all([
    takeLeading(types.getAll, onGetAll),
    takeEvery(types.update, onUpdate),
    takeEvery(types.sync, onSync),
  ]);
}
